import { render, staticRenderFns } from "./TituloPage.vue?vue&type=template&id=6ba2fe0f"
import script from "./TituloPage.js?vue&type=script&lang=js&external"
export * from "./TituloPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports